
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Separator } from "@/components/ui/separator";
import { GoogleButton } from "./GoogleButton";

interface AuthFormProps {
  email: string;
  setEmail: (email: string) => void;
  password: string;
  setPassword: (password: string) => void;
  companyName: string;
  setCompanyName: (companyName: string) => void;
  isLogin: boolean;
  setIsLogin: (isLogin: boolean) => void;
  loading: boolean;
  handleAuth: (e: React.FormEvent) => Promise<void>;
  handleGoogleSignIn: () => Promise<void>;
  teamMemberId?: string | null;
  appsumoCode?: string | null;
}

export const AuthForm = ({
  email,
  setEmail,
  password,
  setPassword,
  companyName,
  setCompanyName,
  isLogin,
  setIsLogin,
  loading,
  handleAuth,
  handleGoogleSignIn,
  teamMemberId,
  appsumoCode,
}: AuthFormProps) => {
  return (
    <div className="w-full max-w-md space-y-8 p-8">
      <div className="text-center">
        <h2 className="text-2xl font-bold">
          {appsumoCode
            ? "Create Your Pro Account"
            : teamMemberId
            ? "Accept Team Invitation"
            : isLogin
            ? "Login"
            : "Sign Up"}
        </h2>
        <p className="text-muted-foreground mt-2">
          {appsumoCode
            ? "Create your account to activate your AppSumo pro license"
            : teamMemberId
            ? "Create your account to join the team."
            : isLogin
            ? "Welcome back! Please login to your account."
            : "Create a new account to get started."}
        </p>
      </div>

      <form onSubmit={handleAuth} className="space-y-6">
        <div className="space-y-2">
          <Label htmlFor="email">Email</Label>
          <Input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="Enter your email"
            disabled={!!teamMemberId}
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="password">Password</Label>
          <Input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            placeholder="Enter your password"
          />
        </div>

        {!isLogin && !teamMemberId && (
          <div className="space-y-2">
            <Label htmlFor="companyName">Company Name</Label>
            <Input
              id="companyName"
              type="text"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
              required
              placeholder="Enter your company name"
            />
          </div>
        )}

        <Button type="submit" className="w-full" disabled={loading}>
          {loading
            ? "Loading..."
            : appsumoCode
            ? "Create Pro Account"
            : teamMemberId
            ? "Accept Invitation"
            : isLogin
            ? "Login"
            : "Sign Up"}
        </Button>
      </form>

      {!appsumoCode && (
        <>
          <div className="relative flex items-center justify-center mt-6">
            <Separator className="flex-grow" />
            <span className="mx-4 text-sm text-muted-foreground">OR</span>
            <Separator className="flex-grow" />
          </div>

          <GoogleButton onClick={handleGoogleSignIn} loading={loading} />
        </>
      )}

      {!teamMemberId && !appsumoCode && (
        <div className="text-center mt-4">
          <button
            type="button"
            onClick={() => setIsLogin(!isLogin)}
            className="text-primary hover:underline"
          >
            {isLogin
              ? "Don't have an account? Sign up"
              : "Already have an account? Login"}
          </button>
        </div>
      )}
    </div>
  );
};
